import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import {deleteKey} from '../../utils/exportMethods';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationModal from '../ui/ConfirmationModal';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL;

const dataSource = createStore({
  key: "geoElementId",
  loadUrl: `${url}/GeoElementMicroservice/subzones`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/GeoElementMicroservice`, ///DeleteOrder
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportSubzonesToExcel = async (apiData) => {
  apiData.forEach(obj => {
    deleteKey(obj, 'geoElementId');
    deleteKey(obj, 'level');
    deleteKey(obj, 'subZoneGeoElementId');
    deleteKey(obj, 'zoneGeoElementId');
  });

  const headers = [
    { header: 'Subzone', key: 'name', autoFit: true },
    { header: 'Zone', key: 'zoneName', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'subzones_extract', 'Subzones Extract');
};

class SubZone extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          Zones: [],
          showCountryMenu: true,
          showZoneMenu: true,
          showSubZoneMenu: true,
          fullscreen:false,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          msg: "",
          oldCheckValue: false,
          validation: true,
          nameVal:true,
          zoneVal:true,
          duplicatedValidation:true,
          subZone:[],
          selectedRowName:"",
        };
        
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }
      
     // to refresh our datagrid table and close all modals
     useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }

  openModal = () => {   
     this.setState({showModal:true, duplicatedValidation: true ,
      validation:true, nameVal:true, zoneVal:true});
    }

  onCreateSubzone = () => {
    this.setState({ duplicatedValidation: true })
    let name = this.refs.Name.value.trim();
    let zone = this.refs.optionZones.value;

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }

    if (zone == "") {
      this.setState({ zoneVal: false })
    } else {
      this.setState({ zoneVal: true })
    }

    if (name != "" && zone != "") {

      let SubzoneInfo = {
        Name: name,
        ParentGeoElementId: zone,
        IsEnabled: true
      };
      apiClient.post(`${url}/GeoElementMicroservice/subzones`, SubzoneInfo)
        .then(response => {
          if (response) {
            const data = response.data;
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Subzone has been created');
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }
    
  onEditSubzone = () => {
    let name = this.refs.Name_Edit.value.trim();
    let zone = this.refs.EditoptionZones.value;
    this.setState({ duplicatedValidation: true })

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (zone == "") {
      this.setState({ zoneVal: false })
    } else {
      this.setState({ zoneVal: true })
    }

    if (name != "" && zone != "") {

      let SubzoneInfo = {
        geoElementId: this.state.selectedRowIndex,
        Name: name,
        ParentGeoElementId: zone,
        IsEnabled: this.state.oldCheckValue
      };
      apiClient.put(`${url}/GeoElementMicroservice`, SubzoneInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {

              if (this.state.oldCheckValue != this.refs.chk_Is_Enabled.checked) {

                if (this.refs.chk_Is_Enabled.checked == true) {
                  this.setState({ msg: "You can't enable this Subzone because it is linked to a disabled Zone. Please modify the Zone selected or go to Zones administration to enable the current one." });
                }
                if (this.refs.chk_Is_Enabled.checked == false) {
                  this.setState({ msg: "You can't disable this Subzone because it is linked to enabled country/countries. Please remove it/them from the list or go to Country/Region administration to disable it/them." });
                }
                this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              } else {
                toast.success('Subzone has been updated');
                this.useRefresh();
              }
            }
          }
        });
    } else {
      this.setState({ validation: false });
      return;
    }
  }

  showDisabledEnabledToast = (value) => {
    if (!this.confDiag.current.state.inEditMode) {
      if (!value) {
        toast.success('Subzone has been enabled');
      }
      else {
        toast.success('Subzone has been disabled');
      }
    }
    else {
      if (value) {
        toast.success('Subzone has been enabled');
      }
      else {
        toast.success('Subzone has been disabled');
      }
    }
  }

  compare( a, b ) {
    if ( a.name < b.name ){
      return -1;
    }
    if ( a.name > b.name ){
      return 1;
    }
    return 0;
  }

  openEditModal = (e) => {  
    const subZoneName = e.row.data.name.trim();
    this.setState({duplicatedValidation: true,showEditModal:true,  validation:true, nameVal:true, zoneVal:true});     
    this.setState({selectedRowIndex: e.row.data.geoElementId, selectedRowName : subZoneName}); 

   const enabledZones = this.state.Zones.filter(obj => {
    return obj.isEnabled === true;
  });
  this.setState({Zones:enabledZones });
    if(
      enabledZones.find(x=>x.geoElementId == e.row.data.zoneGeoElementId) == undefined){
        var l_Zones = enabledZones;
        l_Zones.push( {
          geoElementId:e.row.data.zoneGeoElementId,
          name :e.row.data.zoneName
        })
        l_Zones.sort( this.compare );
        this.setState({Zones:l_Zones })
      }

      this.refs.Name_Edit.value = e.row.data.name;
      this.refs.EditoptionZones.value = e.row.data.zoneGeoElementId;
      this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled;
      this.setState({oldCheckValue: e.row.data.isEnabled});
  }
  
  onExportToExcel = () => {
    apiClient.get(`${url}/GeoElementMicroservice/subzones`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportSubzonesToExcel(data);
          toast.success('Subzones Excel export file has been generated');
        }
      });
  }

  fetchZones() {
    let initialzones = [];
    apiClient.get(`${url}/GeoElementMicroservice/zonesadmindropdown?isEnabled=true`)
      .then(response => {
        const data = response.data;
        initialzones = data;
        this.setState({
          Zones: initialzones,
        });
      });
  }

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      showCountryMenu: decoded.can_manage_country === "true",
      showZoneMenu: decoded.can_manage_zone === "true",
      showSubZoneMenu: decoded.can_manage_subzone === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });
    this.fetchZones();
  }

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
}
  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
}
onDelete = (e) => {

  if (e.row.data.isEnabled == false){
    this.setState({msg :"You can't enable this Subzone because it is linked to a disabled Zone. Please modify the Zone selected or go to Zones administration to enable the current one."});
  }
  if (e.row.data.isEnabled == true){
    this.setState({msg :"You can't disable this Subzone because it is linked to enabled country/countries. Please go to Country/Region administration to disable it/them or modify its/their associated Subzone."});
  }

  this.confDiag.current.state.key = e.row.data.geoElementId;  
  this.confDiag.current.state.status = e.row.data.isEnabled;
  this.confDiag.current.state.inEditMode = false;
  this.confDiag.current.handleOpenConfirmDialog();
}
  render() {

  let l_Zones = this.state.Zones;
  let optionZones = l_Zones.map((zone) =>
      <option value={zone.geoElementId}>{zone.name}</option>
  );

  const columns = [
    { dataField: "isEnabled", caption: "Status", width: "110" },
    { dataField: "name", caption: "Subzone", width: "33%"},
    { dataField: "zoneName", caption: "Zone", width: "33%"},
    // Add other columns specific to Profiles component
  ];

  const buttonColumn = [
    {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
    {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
    {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
    // Additional buttons for Profiles component
  ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>            
           {'Geography > Subzones Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Subzone</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
         <div className="div-body-submenu">
          <div className={this.state.showZoneMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('zones')} >              
             <div class="div-submenu-label">
                    <label>Zones</label>
                </div> 
                            
            </div>
            <div className={this.state.showSubZoneMenu ? "div-submenu-link active" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('subzones')} >              
             <div class="div-submenu-label">
                    <label>Subzones</label>
                </div> 
                            
            </div>
            <div className={this.state.showCountryMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('countries')} >              
             <div class="div-submenu-label">
                    <label>Country/Region</label>
                </div> 
                            
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">

        <CustomDataGrid
              dataSource={dataSource}
              keyExpr="subzoneId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>
      
      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Subzone</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Subzone already exists, your updates cannot be saved. Please go back to Subzones Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Subzone form is not allowed</p></Row>  }
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label  className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
          <Form.Group className="mb-3 col-md-12" controlId="zone">
              <Form.Label className={`${this.state.zoneVal ? "normal-title" : "validation-title"}`}>Zone  <CircleSign/></Form.Label>
              <Form.Control 
                className={`select-placeholder ${!this.state.zoneVal && "validation-control"}`}
                ref="optionZones"  
                placeholder="Zone" 
                as="select" 
                type="select" 
                required
                defaultValue=""
                >
                <option value="" hidden>Zone</option>
                  {optionZones}                                
              </Form.Control>
              {!this.state.zoneVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateSubzone}>
            Create Subzone
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>


      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Subzone</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Subzone already exists, your updates cannot be saved. Please go back to Subzones Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Subzone form is not allowed</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name_Edit" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
          <Form.Group className="mb-3 col-md-12" controlId="zone">
            <Form.Label className={`${this.state.zoneVal ? "normal-title" : "validation-title"}`}>Zone  <CircleSign/></Form.Label>   
             
              <Form.Control ref="EditoptionZones" placeholder="Zone" as="select" type="select" className={`${!this.state.zoneVal && "validation-control"}`}>
              <option value="" hidden>Zone</option>
                  {optionZones}                                
              </Form.Control>
              {!this.state.zoneVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row> 
          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditSubzone}>
            Update Subzone
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="GeoElementMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't enable/disable Subzone" msg={this.state.msg}></ConfirmDialog>
      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default SubZone;
